import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Col, Modal, Row, Form, Select, notification } from "antd";
import SelectPaginacao from "../../selects/selectPaginacao";
import api from "../../../services/api";
import { getParametrosLocal } from "../../../services/auth";


export default function ModalOperacaoFiscal({ formOperacao, exibirModalOperacao, fecharModalOperacao }) {

    function salvarOperacaoLocal() {
        let opeId = formOperacao.getFieldValue("ope_id");
        let parametroLocal = getParametrosLocal();
        let parametros = {
            par_id: parametroLocal.par_id,
            ope_id: opeId
        };
        api.put('ParametroLocal/Editar', parametros).then(
            res => {
                const novoParametroLocal = {
                    ...parametroLocal,
                    ope_id: opeId
                };
                localStorage.setItem("@GestorWeb-ParametrosLocal", JSON.stringify(novoParametroLocal));
                notification.success({ message: 'Operação concluída', description: "Operação Fiscal salva com Sucesso!" });
                fecharModalOperacao();
            }).catch(
                error => {
                    console.log(error);
                }).finally(
                    () => {
                    });
    };

    return (
        <Modal centered
            title="Selecione a Operação Fiscal"
            open={exibirModalOperacao}
            getContainer={false}
            onCancel={fecharModalOperacao}
            onOk={() => salvarOperacaoLocal()}
            okText={
                <>
                    <CheckOutlined /> Ok
                </>
            }
            cancelText={
                <>
                    <CloseOutlined /> Cancelar
                </>
            }
            maskClosable={false}
            width={690}
        >
            <div className="col-modal">
                <Form layout="vertical" name="operacaoFiscal" form={formOperacao}>
                    <Row gutter={[8, 8]}>
                        <Col span={24} >
                            <Form.Item label="Operação Fiscal " name="ope_id">
                                <SelectPaginacao url="OperacaoFiscal/ListarOperacaoFiscal?SomenteAtivo=true&TipoOperacao=1"
                                    placeholder="Selecione a Operação Fiscal"
                                    allowClear
                                    form={formOperacao}
                                    nameValue="ope_id"
                                    nameLabel="ope_descricao"
                                    conteudo={
                                        op => (<Select.Option label={op.ope_descricao} value={op.ope_id} key={op.key}>{op.ope_descricao}</Select.Option>)
                                    }
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </div>
        </Modal>
    );
}